<template>
  <div class="pay-container">
    <van-nav-bar :title="$route.meta.title">
      <template #left>
        <van-icon @click="back" name="arrow-left" color="#46474B" size="20px" />
      </template>
    </van-nav-bar>
    <div class="pay-loading text-align-center">
      <img src="@/assets/pay-state/pay-loading.png" alt="">
      <p>支付查询中({{ second }}s)...</p>
    </div>
  </div>
</template>

<script>
import { speedOrderQuery } from '@/api/speedOrder'
import { callApp } from "@/libs/bridge";
import { NavBar,Icon } from 'vant';

export default {
  components: {
    'van-icon': Icon,
    'van-nav-bar': NavBar
  },
  data(){
    return{
      second: 8,
      timer: ''
    }
  },
  mounted() {
    window.physicsBackFn = this.back
    /* 延迟5s后查询订单状态*/
    this.timer = setInterval(() => {
      this.second--
      if(this.second === 0){
        clearInterval(this.timer)
        /* 查询订单状态*/
        speedOrderQuery(this.$route.query.outTradeNo).then(({ data }) => {
          if(data.orderStatus === 1001){
            this.$router.push({
              path: `/pay/pay-success?sourceId=${data.caseSourceId}&caseSourceType=${data.caseSourceType}&imSessionId=${data.imSessionId}&lawyerId=${data.lawyerId}`
            })
            return false
          }
          this.$router.push({
            path: `/pay/pay-error?orderId=${this.$route.query.orderId}&caseSourceType=${data.caseSourceType}&imSessionId=${this.$route.query.imSessionId}&lawyerId=${data.lawyerId}&caseSourceId=${data.caseSourceId}`
          })
        })
      }else{
        speedOrderQuery(this.$route.query.outTradeNo).then(({ data }) => {
          if(data.orderStatus === 1001){
            clearInterval(this.timer)
            this.$router.push({
              path: `/pay/pay-success?sourceId=${data.caseSourceId}&caseSourceType=${data.caseSourceType}&imSessionId=${data.imSessionId}&lawyerId=${data.lawyerId}`
            })
            return false
          }
        })
      }
    }, 1000)
  },
  methods:{
    back(){
      callApp('finishActivity')
    },
  },
  destroyed() {
    clearInterval(this.timer)
  }
}
</script>

<style scoped lang="scss">

.pay-container{
  min-height: 100vh;
  background: white;
}
.pay-loading{
  font-size: 0;
  img{
    padding-top: 48px;
    width: 121px;
    height: 120px;
  }
  p{
    padding: 29px 0 48px;
    font-size: 18px;
    color: #333333;
  }
}
</style>
